export default {
  title: 'Experiencia Profesional',
  images:[
    {
      title: 'Industria Comercial y de Producción',
      img: require('@/assets/iconos/industria_comercial.png')
    },
    {
      title: 'Industria Manufacturera y Exportadoras de toda Naturaleza',
      img: require('@/assets/iconos/industria_manufacturera.png')
    },
    {
      title: 'Compañías de Servicios',
      img: require('@/assets/iconos/companias_servicios.png')
    },
    {
      title: 'Agro-Comerciales',
      img: require('@/assets/iconos/agro_comerciales.png')
    },
    {
      title: 'Aseguradoras, Financieras, Bancos, Fideicomisos, entre otros',
      img: require('@/assets/iconos/aseguradoras.png')
    },
    {
      title: 'Organizaciones sin fines de lucro',
      img: require('@/assets/iconos/ong.png')
    },
    {
      title: 'Almacenadoras y Zonas Francas',
      img: require('@/assets/iconos/almacenadoras.png')
    },
    {
      title: 'Cooperativas de Ahorro y Crédito Integral y de Servicios varios.',
      img: require('@/assets/iconos/cooperativas.png')
    },
    {
      title: 'Constructoras y Arrendadoras',
      img: require('@/assets/iconos/constructoras.png')
    }
  ],
  control:{
    title: 'Control de Calidad',
    description: 'Trabajamos con estrictos estándares de calidad y rigurosidad, que nos permiten optimizar la gestión de riesgos, preservar el negocio y aportar a la construcción de negocios confiables.',
    description2: 'Nuestro equipo multidisciplinario a través de sus valores y acciones, bajo una línea constante de capacitación, nos posiciona a un alto nivel.'
  },
  responsibles: {
    title: 'Responsables',
    description: 'Nuestro socio director, Jorge A. Román García es quién está a cargo del control de calidad, lo que da confianza a nuestros clientes, además, es quien personalmente se encarga de atender asuntos de alto valor. Sus 40 años de experiencia acreditan su amplia experiencia y un intachable record profesional.',
    description2: 'La disponibilidad y conocimiento hacen que sea la persona indicada para conducir a un equipo de trabajo conformado por profesionales que expanden su experiencia en la práctica adecuada, honesta y confiable. Román García es quien hace cumplir a cabalidad la responsabilidad profesional, la política interna y externa para tranquilidad de nuestros clientes.'
  },
  equipment:{
    title: 'Equipo de Trabajo',
    description: 'El objetivo principal de nuestra práctica, es proveer un servicio de calidad, adaptado a las necesidades del cliente. Esto implica atender cada uno de nuestros trabajos, estructuramos un equipo con las responsabilidades claramente definidas.',
  },
  partner: {
    title: 'Socio Encargado',
    description: 'El líder encargado de los servicios, la ejecución y el encargado de la comunicación con los clientes es Jorge Román Pineda. Su liderazgo y profesionalismo son la guía para el equipo que día a día realiza un trabajo de calidad.',
    description2: 'Es también, el encargado de manejar situaciones puntuales, solución de problemas, supervisión y dirección, con el apoyo de los gerentes de cada área.'
  }
}



// WEBPACK FOOTER //
// ./src/text/es/experience.js